import { Field, InputType, ObjectType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { modelOptions, Prop, Severity } from '@typegoose/typegoose'
import mongoose from 'mongoose'
import { ObjectId } from '../base/ObjectId'

@ObjectType('History')
@modelOptions({ options: { allowMixed: Severity.ALLOW } })
@InputType('HistoryInput')
export class History {
  @Field(() => String)
  @Prop({ type: ObjectId, required: true, default: () => new ObjectId() })
  declare _id: string

  @Field(() => String)
  @Prop({ type: String })
  entityKey: string

  @Field(() => String)
  @Prop({ type: String })
  entity: string

  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date

  @Field(() => String)
  @Prop({ type: String })
  description?: string

  @Field(() => String)
  @Prop({ type: String })
  author: string

  @Field(() => String)
  @Prop({ type: String })
  diff?: string

  @Field(() => GraphQLJSON)
  @Prop({ type: mongoose.Schema.Types.Mixed })
  meta?: object
}
